export default "__VITE_ASSET__DP3KQOtK__"